import { DateTime } from "luxon";

export const formatRevenuePeriod = (period?: string): string | undefined => {
  if (!period) return period;

  const isoPeriod = DateTime.fromISO(period, { setZone: true, zone: "utc" });
  const reportingPeriod = isoPeriod.isValid
    ? isoPeriod
    : DateTime.fromSQL(period, { setZone: true, zone: "utc" });

  return reportingPeriod.isValid ? reportingPeriod.toUTC().toFormat("MM-dd-yyyy") : period;
};